var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getTimeSimplifiedDurationFn, useCadencedTime } from '@timeflies/app-ui';
import React from 'react';
import { TimeGaugeRaw } from './time-gauge-raw';
export var TimeGaugeRawCadenced = function (_a) {
    var startTime = _a.startTime, duration = _a.duration, styleProps = __rest(_a, ["startTime", "duration"]);
    var timeSimplifiedDurationFn = React.useMemo(function () { return getTimeSimplifiedDurationFn({ startTime: startTime, duration: duration }, 3); }, [startTime, duration]);
    var value = useCadencedTime(timeSimplifiedDurationFn);
    return React.createElement(TimeGaugeRaw, __assign({}, styleProps, { duration: value }));
};
